import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles-v2/index.css';
import App from './App';
import reportWebVitals from './utils/reportWebVitals';
import './components/i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

reportWebVitals();